import { render } from "./HeadingOne.vue?vue&type=template&id=c7f790fc&scoped=true"
import script from "./HeadingOne.vue?vue&type=script&lang=js"
export * from "./HeadingOne.vue?vue&type=script&lang=js"

import "./HeadingOne.vue?vue&type=style&index=0&id=c7f790fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f790fc"]])

export default __exports__